/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  heading: {
    marginBottom: 8,
    fontWeight: 500,
    lineHeight: 1.2,
  },
  h1: {
    fontSize: 40,
  },
  h2: {
    fontSize: 32,
  },
  h3: {
    fontSize: 28,
  },
  h4: {
    fontSize: 24,
  },
  h5: {
    fontSize: 20,
  },
  h6: {
    fontSize: 16,
  },
  page: {
    padding: 20,
    fontSize: 10,
    lineHeight: 1.5,
    color: '#3E4B5B',
    flexDirection: 'column',
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  tableheader: {
    flexDirection: 'row',
    borderBottom: '2px solid #fbc531',
    backgroundColor: '#f5f6fa',
    width: '100%',
    fontWeight: 'bold',
  },
  thead: {
    width: 'calc(100% / 6)',
    paddingTop: 8,
    paddingBottom: 2,
    paddingLeft: 15,
    paddingRight: 15,
    borderWidth: 0.5,
    borderStyle: 'solid',
    borderColor: '#eee',
    textAlign: 'center',
  },
  tablebody: {
    width: '100%',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  tbody: {
    width: 'calc(100% / 6)',
    paddingTop: 8,
    paddingBottom: 2,
    paddingLeft: 15,
    paddingRight: 15,
    borderWidth: 0.6,
    borderStyle: 'solid',
    borderColor: '#eee',
    textAlign: 'center',
  },
});

function PDFTable(props: any) {
  return <View style={styles.table}>{props.children}</View>;
}

function thead(props: any) {
  return <View style={styles.tableheader}>{props.children}</View>;
}

function tbody(props: any) {
  return <View style={styles.tablebody}>{props.children}</View>;
}

function row(props: { children: any; background?: string }) {
  return <View style={[styles.row, { backgroundColor: props.background }]}>{props.children}</View>;
}

function th({ text }: { text: string }) {
  return (
    <Text style={styles.thead} wrap={false} hyphenationCallback={e => [e]}>
      {text}
    </Text>
  );
}

function td({ text }: { text: string }) {
  return <Text style={styles.tbody}>{text}</Text>;
}

PDFTable.thead = thead;
PDFTable.tbody = tbody;
PDFTable.row = row;
PDFTable.th = th;
PDFTable.td = td;

export default PDFTable;
